<div>
	<h2>Voter Scores</h2>
	<div *ngFor="let vote of displayVotes ; ; let i = index">
		<a routerLink="/profile/{{ vote.username }}"><h3>{{ vote.username }} - {{ vote.voteScore }}</h3></a>
		<div *ngFor="let c of criteria">
			<p>{{ c }}: {{ displayVotes[i].criteria[c] }}</p>
		</div>
		<p *ngIf="error">{{ error }}</p>
	</div>
</div>